import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Cookies from "js-cookie";

// Layout Components
import LeftSidebarMenu from "./components/Layout/LeftSidebarMenu";
import Footer from "./components/Layout/Footer";
import TopNavbar from "./components/Layout/TopNavbar";
import ScrollToTop from "./components/Layout/ScrollToTop";

// Authentication Pages
import SignInForm from "./components/Authentication/SignInForm";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import Logout from "./pages/authentication/Logout";

// Dashboard Pages
import Forms from "./pages/dashboard/forms"; // ✅ Added import for new Forms page
import PatientProfile from "./pages/dashboard/PatientProfile";
/* 🔐 Protected Route Wrapper */
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('neuro_patientportal_auth_token')
  if (!token) {
    return <Navigate to="/authentication/sign-in/" replace />;
  }
  return children;
};

/* 🔓 Auth Route Wrapper (prevents accessing SignIn when already logged in) */
const AuthRoute = ({ children }) => {
  const token = localStorage.getItem('neuro_patientportal_auth_token')
  if (token) {
    return <Navigate to="/dashboard/forms" replace />;
  }
  return children;
};

/* 🧭 Layout Wrapper (reactive detection of current path) */
const LayoutWrapper = ({ children, toggleActive }) => {
  const location = useLocation();

  const isAuthPage = [
    "/authentication/sign-in/",
    "/authentication/forgot-password/",
    "/authentication/logout/",
  ].includes(location.pathname);

  return (
    <>
      {!isAuthPage && (
        <>
          <TopNavbar toggleActive={toggleActive} />
          <LeftSidebarMenu toggleActive={toggleActive} />
        </>
      )}

      <div className="main-content">
        <ScrollToTop />
        {children}
        {!isAuthPage && <Footer />}
      </div>
    </>
  );
};

const App = () => {
  const [active, setActive] = useState(false);
  const toggleActive = () => setActive(!active);

  return (
    <div className={`main-wrapper-content ${active ? "active" : ""}`}>
      <Router>
        <LayoutWrapper toggleActive={toggleActive}>
          <Routes>
            {/* ========== AUTHENTICATION ROUTES ========== */}
            <Route
              path="/authentication/sign-in/"
              element={
                <AuthRoute>
                  <SignInForm />
                </AuthRoute>
              }
            />
            <Route
              path="/authentication/forgot-password/"
              element={<ForgotPassword />}
            />
            <Route path="/authentication/logout/" element={<Logout />} />


            {/* ✅ NEW → Protected Route for “Forms” page */}
            <Route
              path="/dashboard/forms"
              element={
                <ProtectedRoute>
                  <Forms />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/patient-profile"
              element={
                <ProtectedRoute>
                  <PatientProfile />
                </ProtectedRoute>
              }
            />

            {/* ========== FALLBACK / DEFAULT REDIRECTS ========== */}
            <Route
              path="/"
              element={<Navigate to="/authentication/sign-in/" replace />}
            />
            <Route
              path="*"
              element={<Navigate to="/dashboard/forms" replace />}
            />
          </Routes>
        </LayoutWrapper>
      </Router>
    </div>
  );
};

export default App;